import { render, staticRenderFns } from "./GuideDialog.vue?vue&type=template&id=47f051a6&scoped=true"
import script from "./GuideDialog.vue?vue&type=script&lang=js"
export * from "./GuideDialog.vue?vue&type=script&lang=js"
import style0 from "./GuideDialog.vue?vue&type=style&index=0&id=47f051a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f051a6",
  null
  
)

export default component.exports